import GraphemeSplitter from 'grapheme-splitter';

// 将来Intl.Segmenterが利用可能になったら置き換える
// https://github.com/tc39/proposal-intl-segmenter
const splitter = new GraphemeSplitter();

export function extractInvalidChars(str: string): string[] | undefined {
  const split = splitter.splitGraphemes(str).filter(s => s.length >= 2);
  return split.length > 0 ? split : undefined;
}

export function createInvalidCharText(invalidChars: string[]) {
  const distinctChars = Array.from(new Set(invalidChars));
  if (distinctChars.length > 10) {
    const sliced = distinctChars.slice(0, 10);
    return `${sliced.join('')}... `;
  } else {
    return distinctChars.join('');
  }
}
